module.exports = __webpack_public_path__ + "static/media/graphic22.18336443.png";